import { ReactNode } from 'react'
import { PageDescriptor } from '../../pages/types'
import { Scenario } from '../scenarios/data'

export type BrickPageProps<TBrick extends Brick> = {
    scenario: Scenario
    brick: TBrick
}

export abstract class Brick {
    abstract get title(): string;
    abstract get sortIndex(): number;
    abstract get license(): string | null;
    abstract getPages(): Generator<PageDescriptor>;
    abstract key(): string;
    abstract describe(): ReactNode;
    
    public get icon(): string | null {
        return null;
    }
}
